import { useEffect } from 'react';

interface UsePasteDatabaseContentProps {
  onPaste: (items: DataTransferItemList) => void;
}

/**
 * Registers a document event listener that reacts to pasting (rich) text or files.
 */
export const usePasteListener = ({ onPaste }: UsePasteDatabaseContentProps) => {
  useEffect(() => {
    const pasteListener = (e: ClipboardEvent) => {
      if (!(e.target as HTMLElement)?.closest?.('input,textarea')) {
        e.preventDefault();
        if (e.clipboardData) {
          onPaste(e.clipboardData.items);
        }
      }
    };

    document.addEventListener('paste', pasteListener);
    return () => {
      document.removeEventListener('paste', pasteListener);
    };
  }, [onPaste]);
};
